import React from "react"
import PropTypes from "prop-types"
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "ksc-portal-common-components/shadcn"
import { ChevronDown } from "lucide-react"

const UserSettingsDropdown = ({ data, defaultValue, onChange }) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button variant="outline">
        {defaultValue}
        <ChevronDown className="ml-2 h-4 w-4" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent>
      {data.map(({ name, value }) => (
        <DropdownMenuItem key={name} onClick={() => onChange(value)}>
          {name}
        </DropdownMenuItem>
      ))}
    </DropdownMenuContent>
  </DropdownMenu>
)

UserSettingsDropdown.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
    })
  ).isRequired,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}

UserSettingsDropdown.defaultProps = {
  defaultValue: "",
}

export default UserSettingsDropdown
